import { PinnedItemIcon } from 'library/icons';
import { FC } from 'react';
import { Para, Theme } from 'uie/components';

type Props = {
  message: string;
  onClick: () => void;
};

const { theme } = Theme;

export const PinnedNote: FC<Props> = ({ message, onClick }) => {
  return (
    <div className="incident-detail-responses-pinned-message-block">
      <div className="pinned-message-bar" onClick={onClick}>
        <div className="pinned-icon">
          <PinnedItemIcon />
        </div>
        <div style={{ padding: '0px 6px', minWidth: 0 }}>
          <Para fontSize={14.5} color={theme.shades.cement} className="pinned-message">
            Resolution reason: {message}
          </Para>
        </div>
      </div>
    </div>
  );
};
